"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.MOBILE_ZINDEX_VALUE = exports.CONTAINER_HEIGHT = void 0;
var TRANSLATION = {
  drinksLabel: 'Select Drink',
  noDrinksAvailable: 'No Drinks Available'
};
exports.TRANSLATION = TRANSLATION;
var CONTAINER_HEIGHT = '48px';
exports.CONTAINER_HEIGHT = CONTAINER_HEIGHT;
var MOBILE_ZINDEX_VALUE = 25;
exports.MOBILE_ZINDEX_VALUE = MOBILE_ZINDEX_VALUE;
var TEXT_TYPE = {
  normal: {
    type: 'textNormal',
    color: 'neutral'
  },
  XSmall: {
    type: 'XSmall',
    color: 'neutral'
  },
  small: {
    type: 'small',
    color: 'greyDark'
  },
  medium: {
    type: 'small',
    color: 'greyDarker'
  },
  large: {
    type: 'textLarge',
    color: 'neutral'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;